import React from 'react'

import EmptyIcon from './EmptyIcon'

import useStyles from './styles'

const NoSelect = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.holder}>
        <EmptyIcon className={classes.icon} />

        <div className={classes.label}>No Conversation Opened</div>
      </div>
    </div>
  )
}

export default NoSelect
